import React from 'react';
import Paper from "@material-ui/core/Paper/index";
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {Divider} from "@material-ui/core";
import TitlePage from "../../../../app/Title/TitlePage/TitlePageView";
import LinearProgress from "@material-ui/core/LinearProgress";
import {Dropdown} from "primereact/dropdown";
import SubtitleLabel from "../../../../app/Title/SubtitleLabel/SubtitleLabelView";

const EditInstrumentView = (props) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                {props.messagesGrowl}
                <div className="p-grid">
                    <div className="p-col-8">
                        <TitlePage title="Mantenimiento \ Emisoras \ Editar"/>
                    </div>
                    <div className="p-col-4" align="right">
                        <Button label="Regresar" className="p-button-secondary"
                                onClick={props.returnMaintenancePage}/>
                        &nbsp;
                        <Button label="Guardar" onClick={props.updateInstrument}
                        />
                    </div>
                    <div className="p-col-12">
                        <Divider/>
                    </div>
                    <div className="p-col-12">
                        <SubtitleLabel header="Emisora" isBold={true}/>
                        <SubtitleLabel header={props.instrumentData.emisoraSerie} />
                    </div>
                    <div className="p-col-6 ">
                        <SubtitleLabel header="Cupón" isBold={true}/>
                        <InputText name="cupon" placeholder="Ex:cupon"
                                   required={true} maxLength={10}
                                   keyfilter={"pint"}
                                   value={props.instrumentData.cupon}
                                   onChange={props.onChangeInputText}/>
                    </div> <div className="p-col-6"/>
                    <div className="p-col-6 ">
                        <SubtitleLabel header="ISIN" isBold={true}/>
                        <InputText name="isin" placeholder="Ex:isin"
                                   required={true} maxLength={15}
                                   keyfilter={"alphanum"}
                                   value={props.instrumentData.isin}
                                   onChange={props.onChangeInputText}/>
                    </div><div className="p-col-6"/>
                    <div className="p-col-6 ">
                        <SubtitleLabel header="ID GSS" isBold={true}/>
                        <InputText name="idGSS" placeholder="Ex:id Gss"
                                   required={true} maxLength={35}
                                   keyfilter={/^[a-zA-Z0-9-*]+/}
                                   value={props.instrumentData.idGSS}
                                   onChange={props.onChangeInputText}/>
                    </div><div className="p-col-6"/>
                    <div className="p-col-6">
                        <SubtitleLabel header="Clave Aforo" isBold={true}/>
                        <Dropdown name="cveAforoObj"
                                  options={props.clavesList}
                                  filterBy="aforoStr"
                                  optionLabel="aforoStr"
                                  placeholder="Seleccione..."
                                  onChange={props.onChangeInputText}
                                  value={props.instrumentData.cveAforoObj}
                        />
                    </div><div className="p-col-6"/>
                    <div className="p-col-6 ">
                        <SubtitleLabel header="Disponibilidad" isBold={true}/>
                        <Dropdown name="availabilityObj"
                                  options={props.availabilityList}
                                  filterBy="availability"
                                  optionLabel="availability"
                                  placeholder="Seleccione..."
                                  onChange={props.onChangeInputText}
                                  value={props.instrumentData.availabilityObj}
                        />
                    </div><div className="p-col-6"/>
                </div>
            </Paper>
        </React.Fragment>
    )
};

export default /*withStyles(styles)*/(EditInstrumentView);